/**
 * Estado de gestión de un consumo, tal como lo define el backend
 * (`ProtocolConsumedServiceStatus`).
 */
export enum ProtocolConsumedServiceStatus {
  NotSettled = 0,
  Pending = 1,
  Payee = 2,
  Settled = 3,
  Rejected = 4,
  Ignored = 5,
  ToSettle = 6,
  Invoiced = 7,
  PartialSettled = 8
}

export interface ProtocolConsumedServiceStatusOption {
  key: ProtocolConsumedServiceStatus;
  /** Clave en `protocolConsumedServiceStatus.*` de los archivos de traducción. */
  textKey: string;
  /** Texto de respaldo si falta la traducción. */
  defaultText: string;
  color: string;
}

/** Color de un estado que no está en el enum; el mismo `status-unknown` de la lista. */
export const UnknownConsumedServiceStatusColor = '#666666';

/**
 * Nombre traducible y color de cada estado.
 *
 * Los colores son los de la lista de consumos del protocolo
 * (`ConsumptionList.Styles.css`, clases `status-*`): un estado tiene que verse
 * igual en el gráfico que en la lista de donde salen esos consumos. Si cambian
 * allá, hay que cambiarlos acá.
 */
export const ProtocolConsumedServiceStatusOptions: ProtocolConsumedServiceStatusOption[] = [
  { key: ProtocolConsumedServiceStatus.NotSettled, textKey: 'protocolConsumedServiceStatus.notSettled', defaultText: 'Pendiente de liquidación', color: '#ffcc00' },
  { key: ProtocolConsumedServiceStatus.Pending, textKey: 'protocolConsumedServiceStatus.pending', defaultText: 'Con saldo pendiente', color: '#ff9100' },
  { key: ProtocolConsumedServiceStatus.Payee, textKey: 'protocolConsumedServiceStatus.payee', defaultText: 'Pagado', color: '#39b828' },
  { key: ProtocolConsumedServiceStatus.Settled, textKey: 'protocolConsumedServiceStatus.settled', defaultText: 'Liquidado', color: '#3399ff' },
  { key: ProtocolConsumedServiceStatus.Rejected, textKey: 'protocolConsumedServiceStatus.rejected', defaultText: 'Rechazado', color: '#ff3300' },
  { key: ProtocolConsumedServiceStatus.Ignored, textKey: 'protocolConsumedServiceStatus.ignored', defaultText: 'Ignorado', color: '#cccccc' },
  { key: ProtocolConsumedServiceStatus.ToSettle, textKey: 'protocolConsumedServiceStatus.toSettle', defaultText: 'Por liquidar', color: '#0044ff' },
  { key: ProtocolConsumedServiceStatus.Invoiced, textKey: 'protocolConsumedServiceStatus.invoiced', defaultText: 'Facturado', color: '#800080' },
  { key: ProtocolConsumedServiceStatus.PartialSettled, textKey: 'protocolConsumedServiceStatus.partialSettled', defaultText: 'Liquidado parcialmente', color: '#008080' }
];
